module.exports = __webpack_public_path__ + "fork_left.svg?b13e1e26f418bee17e5de99439e42d92";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/fork_left.svg
// module id = 165
// module chunks = 0